import { getCookie, setCookie } from 'shared/helpers/utils';

export const GRAHAK_AUTH_COOKIE = 'EXP_auth-ghk';
const GRAHAK_AUTH_COOKIE_VALUE = '1';
const GRAHAK_AUTH_COOKIE_DURATION_DAYS = 1;

export const syncGrahakAuthCookie = (isGrahakEnabled: boolean): void => {
  if (typeof document === 'undefined') {
    return;
  }

  try {
    const currentValue = getCookie(GRAHAK_AUTH_COOKIE);

    if (isGrahakEnabled && currentValue !== GRAHAK_AUTH_COOKIE_VALUE) {
      setCookie(
        GRAHAK_AUTH_COOKIE,
        GRAHAK_AUTH_COOKIE_VALUE,
        GRAHAK_AUTH_COOKIE_DURATION_DAYS
      );
    } else if (!isGrahakEnabled && currentValue !== '') {
      setCookie(GRAHAK_AUTH_COOKIE, '', -1);
    }
  } catch (error) {
    // Cookie restrictions must not block the API request being prepared.
    void error;
  }
};
